import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { useState } from 'react'
import { FancyToggle } from 'apps/builder/components/settings/modal'

export const EditableToggle = ({ guid, style }) => {
  const dispatch = useDispatch()
  const [editableToggle, setEditableToggle] = useState(style == 34)
  return (
    <div className="single-choice--editable-toggle--container">
      <FancyToggle
        label="Allow users to add choices on mobile"
        id={guid}
        active={editableToggle}
        inlineStyle={true}
        onChange={checked => {
          checked ? setEditableToggle(true) : setEditableToggle(false)
          dispatch(
            updateEntry({
              guid,
              style: checked ? 34 : 3,
            })
          )
        }}
      />
      <div className="foundry--surface surface--info info--block">
        <p>
          Choices added this way will not appear for other users or in the
          future Submissions (unless added again manually).
        </p>
      </div>
    </div>
  )
}
